/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RafflePoolController } from "../RafflePoolController";

export class RafflePoolController__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _mintToken: string,
    overrides?: Overrides
  ): Promise<RafflePoolController> {
    return super.deploy(
      _mintToken,
      overrides || {}
    ) as Promise<RafflePoolController>;
  }
  getDeployTransaction(
    _mintToken: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_mintToken, overrides || {});
  }
  attach(address: string): RafflePoolController {
    return super.attach(address) as RafflePoolController;
  }
  connect(signer: Signer): RafflePoolController__factory {
    return super.connect(signer) as RafflePoolController__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RafflePoolController {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as RafflePoolController;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "PoolCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "PoolEnd",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    name: "PoolMax",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "PoolPrice",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "PoolResult",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
    ],
    name: "PoolStart",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "open",
        type: "bool",
      },
    ],
    name: "PoolStatus",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "PoolTokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "PoolTokenTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "CONFIG_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "addAdminToPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "addPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "emitTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "getPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUserBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "mintWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "poolFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "removeAdminFromPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "requestIdsToPool",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
    ],
    name: "setMintToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setPoolBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "setPoolEnd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolFactory",
        type: "address",
      },
    ],
    name: "setPoolFactory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "setPoolPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
    ],
    name: "setPoolStart",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "open",
        type: "bool",
      },
    ],
    name: "setPoolStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    name: "setPoolSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "users",
        type: "address[]",
      },
    ],
    name: "whitelistAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
